// @ts-nocheck
import { useState } from 'react';
// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { Stack, Button, Group, Modal, TextInput, NumberInput, Select, Textarea } from '@mantine/core';
// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { useForm } from '@mantine/form';
import { IconPlus } from '@tabler/icons-react';
import { PageHeader } from '../../components/PageHeader';
import { DataTable, type Column } from '../../components/DataTable';
import { StatusBadge } from '../../components/StatusBadge';
import { CurrencyDisplay } from '../../components/CurrencyDisplay';
import { EmptyState } from '../../components/EmptyState';

interface AmendmentRow extends Record<string, unknown> {
  id: string;
  employeeName: string;
  type: string;
  description: string;
  amount: number;
  status: string;
  createdAt: string;
}

const columns: Column<AmendmentRow>[] = [
  { key: 'employeeName', label: 'Employee', sortable: true },
  { key: 'type', label: 'Type', sortable: true, width: 120 },
  { key: 'description', label: 'Description' },
  {
    key: 'amount',
    label: 'Amount',
    sortable: true,
    render: (row) => <CurrencyDisplay amount={row.amount} colored />,
  },
  {
    key: 'status',
    label: 'Status',
    width: 120,
    render: (row) => <StatusBadge status={row.status} />,
  },
  {
    key: 'createdAt',
    label: 'Created',
    sortable: true,
    width: 140,
    render: (row) => new Date(row.createdAt).toLocaleDateString(),
  },
];

export default function AmendmentListPage() {
  const [modalOpen, setModalOpen] = useState(false);

  const form = useForm({
    initialValues: {
      employeeId: '',
      type: 'bonus',
      description: '',
      amount: 0,
    },
  });

  return (
    <Stack>
      <PageHeader
        title="Amendments"
        subtitle="Manage payroll amendments and adjustments"
        breadcrumbs={[{ label: 'Payroll', to: '/admin/workforce/payroll' }, { label: 'Amendments' }]}
        actions={
          <Button icon={<IconPlus size={16} />} onClick={() => setModalOpen(true)}>
            New Amendment
          </Button>
        }
      />

      <DataTable
        columns={columns}
        data={[]}
        emptyMessage="No amendments found. Create one to add a bonus, adjustment, or correction to the next payroll run."
      />

      <Modal
        opened={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Create Amendment"
        size="md"
      >
        <Stack gap="md">
          <TextInput
            label="Employee"
            placeholder="Search employee..."
            required
            {...form.getInputProps('employeeId')}
          />
          <Select
            label="Type"
            required
            data={[
              { value: 'bonus', label: 'Bonus' },
              { value: 'adjustment', label: 'Adjustment' },
              { value: 'correction', label: 'Correction' },
              { value: 'reimbursement', label: 'Reimbursement' },
              { value: 'retroactive', label: 'Retroactive Pay' },
            ]}
            {...form.getInputProps('type')}
          />
          <NumberInput
            label="Amount"
            placeholder="0.00"
            prefix="$"
            decimalScale={2}
            required
            {...form.getInputProps('amount')}
          />
          <Textarea
            label="Description"
            placeholder="Reason for this amendment..."
            required
            {...form.getInputProps('description')}
          />
          <Group justify="flex-end">
            <Button variant="default" onClick={() => setModalOpen(false)}>
              Cancel
            </Button>
            <Button>Create Amendment</Button>
          </Group>
        </Stack>
      </Modal>
    </Stack>
  );
}
